import React from 'react'
import Spinner from '../../../../Spinner/Spinner'
import Icons from '../../../../Icons'
import {_L, useLocaleState} from '../../../../../context/LocaleContext'
import {
  formatRecurrenceText,
  getDayParts
} from '../../../../../utils/recurrence'
import ErrorMessage from '../../../../ErrorContainer'

import {
  Container,
  ButtonContainer,
  ErrorContainer,
  FieldContainer,
  Name,
  SubText,
  ContactInfoText,
  TimeContainer,
  TimeIcon,
  TimeTitle,
  TimeTitleText,
  User,
  UserContact,
  UserName,
  StyledFormButton
} from './StyledSummary'

const getEmployeeInfo = ({employee, booking}) => {
  const {visitorName, isVisitor, visitorEmail, visitorPhone} = booking
  const {emTitle, phone, email, emId, name} = employee

  let info = {
    employeeName: '',
    emTitle: '',
    phone: '',
    email: ''
  }

  if (isVisitor) {
    info.employeeName = visitorName
    info.phone = visitorPhone
    info.email = visitorEmail
  } else {
    info.employeeName = name || emId
    info.phone = phone
    info.emTitle = emTitle
    info.email = email
  }

  return info
}

const Summary = ({
  workspaceSearch,
  booking,
  employee,
  onBook,
  loading,
  error
}) => {
  const localeState = useLocaleState()

  const {
    dayPart,
    frequency,
    frequencyDay,
    weekDays,
    recurrenceType,
    date_start
  } = workspaceSearch

  const {emTitle, phone, email, employeeName} = getEmployeeInfo({
    employee,
    booking
  })

  let recurrenceText = formatRecurrenceText({
    recurrenceType,
    frequency,
    frequencyDay,
    weekDays,
    startDate: date_start,
    localeState
  })

  return (
    <Container>
      <FieldContainer>
        <SubText>{_L({key: 'Booking for', localeState})}</SubText>
        <User>
          <UserName>
            <Name>{employeeName}</Name>
            <SubText>{emTitle}</SubText>
          </UserName>

          <UserContact>
            <ContactInfoText>{phone}</ContactInfoText>
            <ContactInfoText>{email}</ContactInfoText>
          </UserContact>
        </User>

        <TimeContainer>
          <TimeTitle>
            <TimeTitleText>{recurrenceText}</TimeTitleText>
          </TimeTitle>

          <TimeIcon>
            <Icons icon="CALENDAR" />
          </TimeIcon>
        </TimeContainer>

        <TimeContainer>
          <TimeTitle>
            <TimeTitleText>{getDayParts({localeState})[dayPart]}</TimeTitleText>
          </TimeTitle>
          <TimeIcon>
            <Icons icon="CLOCK" />
          </TimeIcon>
        </TimeContainer>

        {error && (
          <ErrorContainer>
            <ErrorMessage errorMessage={error} />
          </ErrorContainer>
        )}
      </FieldContainer>

      <ButtonContainer>
        <StyledFormButton onClick={onBook} data-testid="workspace-book-button">
          {loading ? <Spinner height="20px" /> : _L({key: 'BOOK', localeState})}
        </StyledFormButton>
      </ButtonContainer>
    </Container>
  )
}

export default Summary
